import React, { Component } from 'react';
import { List } from 'antd';
import { ReleaseItem } from '..';
import { ReleaseItemListProps, InjectedProps } from './ReleaseItemListModel';
import { observer, inject } from 'mobx-react';
import styles from './ReleaseItemList.module.scss';

@inject('publishToLiveStore')
@observer
class ReleaseItemList extends Component<ReleaseItemListProps> {
    get injected() {
        return this.props as InjectedProps;
    }
    render() {
        const { loaders: { publish, init }, releaseItems } = this.injected.publishToLiveStore;
        return (
            <List
                className={styles.ListContainer}
                loading={publish || init}
                itemLayout="horizontal"
                dataSource={releaseItems}
                renderItem={item => (
                    <ReleaseItem releaseItem={item} />
                )}
                pagination={{
                    defaultCurrent: 1, total: releaseItems.length, position: 'bottom', showSizeChanger: true
                }}
            />
        );
    }
}

export default ReleaseItemList;
